var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"m-0"},[_c('small',[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"float-right"},[_vm._v(_vm._s(_vm.getPerformance))])]),_c('b-progress',{attrs:{"value":_vm.progress,"max":_vm.max,"height":"6px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }